import styled from 'styled-components';

const shouldForwardProp = prop => !['isOpen'].includes(prop);

export const HousingFundsStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .housingItemSection {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;
